import gql from 'graphql-tag';
export default gql`
  mutation(
    $uploadID: ID!
    $customName: String
  ) {
    finalizeUploadViLabel(
      uploadID: $uploadID
      customName: $customName
    ) {
      uploadID
      customName
      gcsUrl
    }
  }
`;
